import { render, staticRenderFns } from "./PhotoExhibition.vue?vue&type=template&id=715ea07c&scoped=true&"
import script from "./PhotoExhibition.vue?vue&type=script&lang=js&"
export * from "./PhotoExhibition.vue?vue&type=script&lang=js&"
import style0 from "./PhotoExhibition.vue?vue&type=style&index=0&id=715ea07c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ea07c",
  null
  
)

export default component.exports